import { Dialog } from "@mui/material";
import I18n from "common/i18n";
import { CloseBtn, FadeTransition } from "common/elements";
import { useScale, btnDelay, usePlaySound } from "common/utils";

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  planLabel?: string;
};

// 子どもが「保護者にお願いする」前に表示する確認モーダル。
// 保護者のメールアドレスなどの個人情報は子どもに見せない。
export const AskParentModal = ({ open, onClose, onConfirm, planLabel }: Props) => {
  const play = usePlaySound();
  const { scale } = useScale();

  const handleCancel = () => {
    play();
    btnDelay(() => onClose());
  };

  const handleConfirm = () => {
    play();
    btnDelay(() => onConfirm());
  };

  const message = planLabel
    ? I18n.t("MSG_SUBSCRIPTION_ASK_PARENT_MODAL_MESSAGE_WITH_PLAN", { plan: planLabel })
    : I18n.t("MSG_SUBSCRIPTION_ASK_PARENT_MODAL_MESSAGE_NO_PLAN");

  return (
    <Dialog
      open={open}
      maxWidth={false}
      sx={{ zIndex: 2147483646 }}
      TransitionComponent={FadeTransition}
      componentsProps={{ backdrop: { style: { backgroundColor: "rgba(0,0,0,0.3)" } } }}
      PaperProps={{
        style: { margin: 0, overflow: "visible", backgroundColor: "transparent" },
        elevation: 0,
      }}
    >
      <div className="flex-col-el flex-center relative" style={{ transform: `scale(${scale})` }}>
        <div className="flex-col-el justify-start w-[560px] relative border-solid border-white border-[8px] rounded-lg bg-white">
          <CloseBtn close={handleCancel} />
          <div className="flex-col-view justify-start w-full relative p-6 rounded bg-beige-60">
            <div className="flex-row-view items-center justify-start pb-4">
              <div className="flex-col-center mr-2">
                <span className="material-symbols-outlined type-title text-[#ffa03b]">
                  volunteer_activism
                </span>
              </div>
              <p className="type-text type-title text-textcolor-black">
                {I18n.t("MSG_SUBSCRIPTION_ASK_PARENT_MODAL_TITLE")}
              </p>
            </div>

            <div className="flex-col-view items-start py-4">
              <p className="text-body text-textcolor-black type-body">{message}</p>
            </div>

            <div className="flex-row-el flex-center gap-6 mt-4 alpha">
              <button className="btn btn-blue" onClick={handleCancel}>
                <div className="flex-row-center gap-1">
                  <span className="material-symbols-outlined type-title text-white">close</span>
                  <p className="text-body text-white text-font-size-body1">
                    {I18n.t("MSG_SUBSCRIPTION_ASK_PARENT_CANCEL_BTN")}
                  </p>
                </div>
              </button>
              <button className="btn btn-primary" onClick={handleConfirm}>
                <div className="flex-row-center gap-1">
                  <span className="material-symbols-outlined type-title text-white">send</span>
                  <p className="text-body text-white text-font-size-body1">
                    {I18n.t("MSG_SUBSCRIPTION_ASK_PARENT_SEND_BTN")}
                  </p>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
